// src/aws-exports.js

/* const awsconfig = {
  Auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_OpxCBT0CZ', // ← Replace with your Cognito User Pool ID
    userPoolWebClientId: '73a4tp1ugveedli30f28dh1e4a', // ← Replace with your App Client ID
    mandatorySignIn: true,
    oauth: {
      domain: 'us-east-1opxcbt0cz.auth.us-east-1.amazoncognito.com',
      scope: ['email', 'openid', 'profile'],
      redirectSignIn: 'http://localhost:3000/',
      redirectSignOut: 'http://localhost:3000/',
      responseType: 'code',
    },
  },
}; */

/*
const awsconfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_OpxCBT0CZ',
      userPoolClientId: '73a4tp1ugveedli30f28dh1e4a',
      loginWith: {
        email: true,
        phone: false,
        username: false,
      },
    },
  },
  oauth: {
    domain: 'us-east-1opxcbt0cz.auth.us-east-1.amazoncognito.com',
    scope: ['email', 'openid', 'profile'],
    redirectSignIn: 'http://localhost:3000/',
    redirectSignOut: 'http://localhost:3000/',
    responseType: 'code',
    providers: [], // leave empty if not using social login
  },
};

export default awsconfig;
*/

const awsconfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_OpxCBT0CZ',
      userPoolClientId: '73a4tp1ugveedli30f28dh1e4a',
      loginWith: {
        email: true,
        phone: false,
        username: false,
      }
    }
  },
  oauth: {
    domain: 'us-east-1opxcbt0cz.auth.us-east-1.amazoncognito.com',
    scope: ['email', 'openid', 'profile'],
    redirectSignIn: 'http://localhost:3000/',
    redirectSignOut: 'http://localhost:3000/',
    responseType: 'code',
    providers: [] // leave empty if not using social login
  }
};

export default awsconfig;